<template>
  <div>
  <!-- Indique si la licence n'a pas l'option Push -->
  <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
    {{ $t('warningPushDisabled') }}
  </v-alert>
  <div class="push">
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    
    <v-card>
      <template v-for="push in pushs">
        <v-list dense two-line :key="push.id">
          <v-list-tile avatar @click="showPush(push.id)">
            <v-list-tile-avatar>
              <v-icon v-if="push.type == 'picture'">photo_size_select_large</v-icon>
              <v-icon v-else-if="push.type == 'html'">code</v-icon>
              <v-icon v-else>announcement</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ push.name }}</v-list-tile-title><v-list-tile-sub-title>{{ push.type }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                    <v-list-tile @click="openDialogCopy(push.id,push.name)">
                      <v-list-tile-action>
                        <v-icon>content_copy</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ $t('duplicate') | cap }} push</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="openDialogDelete(push.id,push.name)">
                      <v-list-tile-action>
                        <v-icon>delete</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ $t('delete') | cap }} push</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </template>
    </v-card>
    <v-fab-transition>
      <v-btn
        v-if="!alert"
        dark
        class="secondary"
        fab
        fixed
        bottom
        right
        @click.native.stop="openDialogCreate">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- DIALOGUE -->
    <v-dialog v-model="showDialogCreate" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('add') | cap }} push</v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            :label="$t('name') | cap"
            v-model="newPushDialog.name"
            counter
            required
            max="32" 
            v-validate="'max:32'" 
            data-vv-name="newPushName"
            @keyup.native.enter="submitDialogCreate" >
          </v-text-field>
          <v-select
            :label="$t('type') | cap"
            v-model="newPushDialog.style"
            v-bind:items="push_type">
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" flat @click.native="submitDialogCreate">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      alert: false,
       /**
       * indique si une requête ajax en cours
       * @type {Boolean}
       */
      loading: false,
      filtersLoaded: false,
       /**
        * affiche/cache la fenetre de dialog de création
        * @type {Boolean}
        */
      showDialogCreate: false,
       /**
      * nouvelle bibliothèque à créer
      * @type {Object}
      */
      newPushDialog: {style: 'classic'},
      /**
       * indique si la souris est au-dessus du menu de la liste
       * @type {Boolean}
       */
      overMenu: false,
      /**
       * Liste des filtres affiché dans le formulaire
       * @type {Array}
       */
      pushs: [],
      siteKey: '',
      resAjx: null,
      push_type: [
          { text: this.$t('classic') + ' (pop-up)', value: 'classic' },
          { text: this.$t('picture') + ' (1280 x 720 max)', value: 'picture' },
          { text: 'HTML (code)', value: 'html' }
      ]
    }
  },

  mounted () {
    this.loading = true
    this.init()
  },

  methods: {
    init () {
      if (this.$store.state._User.entLevel !== '7' && this.$store.state._User.entOptionPush === 0) {
        this.alert = true
      }
      this.loading = true
      this.resAjx = null
      this.pushs = []

      this.axios.get('get/pushs.php')
      .then(response => {
        this.resAjx = response.data
      })
      .then(_ => {
        this.loading = false
        this.initPush()
      })
      .catch()
    },

    openDialogCopy (_id, _name) {
      if (confirm(this.$t('duplicate') + ' push (' + _name + ') ?')) {
        this.loading = true
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append('id', _id)
        this.axios.post('post/duplicpush.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('duplicateSuccess'), context: 'success' })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('error'), context: 'error' })
        })
        .then(_ => {
          this.axios.get('get/pushs.php')
          .then(response => {
            this.loading = false
            this.resAjx = response.data
            this.pushs = []
            this.initPush()
          })
          .catch()
          .then(_ => {
            this.loading = false
          })
        })
      }
    },

    openDialogDelete (_id, _name) {
      if (confirm(this.$t('delete') + ' push (' + _name + ') ? ' + this.$t('attentionDeletePush'))) {
        this.loading = true
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append('id', _id)
        this.axios.post('delete/push.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteSuccess'), context: 'success' })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('error'), context: 'error' })
        })
        .then(_ => {
          this.axios.get('get/pushs.php')
          .then(response => {
            this.loading = false
            this.resAjx = response.data
            this.pushs = []
            this.initPush()
          })
          .catch()
          .then(_ => {
            this.loading = false
          })
        })
      }
    },

    initPush () {
      for (var n in this.resAjx) {
        // console.log(this.resAjx[n])
        this.pushs.push({ id: this.resAjx[n].PUSH_ID,
          name: this.resAjx[n].PUSH_NAME,
          type: this.resAjx[n].PUSH_STYLE,
          title: this.resAjx[n].PUSH_TITLE,
          content: this.resAjx[n].PUSH_MSG,
          img: this.resAjx[n].PUSH_IMG,
          vibra: this.resAjx[n].PUSH_VIBRA_ONOFF,
          vibraFreq: this.resAjx[n].PUSH_VIBRA_DURATION,
          picture: this.resAjx[n].PUSH_PICTURE,
          link: this.resAjx[n].PUSH_LINK,
          licId: this.resAjx[n].PUSH_LIC_ID,
          active: this.resAjx[n].PUSH_ONOFF,
          html: this.resAjx[n].PUSH_HTML,
          position: this.resAjx[n].PUSH_POSITION,
          posx: this.resAjx[n].PUSH_POSITION_X,
          posy: this.resAjx[n].PUSH_POSITION_Y,
          action: this.resAjx[n].PUSH_ACTION,
          overlay: this.resAjx[n].PUSH_OVERLAY
        })
        this.siteKey = this.resAjx[n].lickey
      }
    },
    /**
     * ouvre la fenêtre de dialogue et initialise un  nouveau filtre à créer
     */
    openDialogCreate () {
      this.showDialogCreate = true
    },
    /**
     * valide la nouvelle bibliothèque à créer
     */
    submitDialogCreate () {
      this.showDialogCreate = false
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('newpush', JSON.stringify(this.newPushDialog))
      // dataToPost.append('site_id', JSON.stringify(this.newPushDialog))
      this.axios.post('post/newpush.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationSuccess'), context: 'success' })
        this.showPush(response.data.id)
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' })
      })
    },

    showPush (_id) {
      // pour éviter de réaliser l'évenement si la souris est au-dessus du bouton de click
      if (!this.overMenu) {
        this.$router.push({ path: '/media/pushs/' + _id })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/Pushs.vue